import { render, staticRenderFns } from "./AddRemark.vue?vue&type=template&id=c7aee532"
import script from "./AddRemark.vue?vue&type=script&lang=js"
export * from "./AddRemark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports